import React from 'react'
import { InfiniteScrollTriggerProps } from './types'

export const InfiniteScrollTrigger: React.FC<InfiniteScrollTriggerProps> = ({
  loadMoreRef,
  isFetchingNextPage,
}) => (
  <div ref={loadMoreRef} className="flex justify-center md:mt-8">
    {isFetchingNextPage && (
      <div className="flex items-center gap-2">
        <div className="h-4 w-4 animate-spin rounded-full border-2 border-t-gray-600"></div>
        <span className="text-sm text-gray-600">Loading more...</span>
      </div>
    )}
  </div>
)
